import type { CreateClientProfileInput } from '../../types/case-management'

export const EMPTY_FORM_DATA: CreateClientProfileInput = {
  name: '',
  shortName: '',
  industry: '',
  referenceCode: '',
  notes: '',
  primaryContactName: '',
  primaryContactEmail: '',
  primaryContactPhone: '',
}

export type DeleteOption = 'reassign' | 'unlink'
